import React from "react";
import { useDispatch } from "react-redux";
import { getPage404Texts, Page404 } from "component-library";

import { setLoading } from "store/ui/ui.actions";

export const Page404Container: React.FC = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setLoading(false));
  }, []);

  return <Page404 texts={getPage404Texts()} homePageLink="/" />;
};

export default Page404Container;
